import React, { useContext, useState, useEffect } from 'react';
import axios from 'axios';

import { UserContext } from '../contexts/index.jsx';
import { Loading } from ".";
import { Table as RsrtTable, Thead, Tbody, Tr, Th } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

const defaultFetchParams = {
  filters: {},
  sort: {
    'field': 'created_at',
    'direction': 'desc'
  }
}

const loadData = async (url, params, limit, callback) => {
  const { data } = await axios.post(url, {
    ...defaultFetchParams,
    ...(params || {}),
    paging: {
      offset: 0,
      limit,
    }
  });

  callback(data.items);
};

const Table = ({
  className = '',
  emptyText = "No results found.",
  rows = [],
  fetchUrl,
  fetchParams,
  fetchLimit = 5,
  headers,
  RowComponent,
  componentProps = {},
  responsive = true,
  onSelectClick,
  addLoggedUserFirst = false,
}) => {
  const [isLoading, setIsLoading] = useState(!rows.length && fetchUrl);
  const [items, setItems] = useState([]);
  const { user } = useContext(UserContext)

  useEffect(() => {
    if (fetchUrl) {
      setIsLoading(true);
      loadData(fetchUrl, fetchParams, fetchLimit, (data) => {
        if (addLoggedUserFirst) {
          setItems([user, ...data]);
        } else {
          setItems(data);
        }
        setIsLoading(false);
      });
    }
  }, [fetchParams, fetchUrl, fetchLimit, addLoggedUserFirst]);

  const table = (headers, items) => {
    const body = items.map((item) => (
      <RowComponent
        item={item}
        key={item.id}
        onSelectClick={onSelectClick ? () => onSelectClick(item) : null}
        {...componentProps}
      />
    ));

    if (responsive) {
      return (
        <RsrtTable className={className}>
          <Thead>
            <Tr>
              {headers.map((content, i) =>
                <Th key={i}>{content}</Th>
              )}
            </Tr>
          </Thead>
          <Tbody>{body}</Tbody>
        </RsrtTable>
      );
    }

    return (
      <table className={className}>
        <thead>
          <tr>
            {headers.map((content, i) =>
              <th key={i}>{content}</th>
            )}
          </tr>
        </thead>
        <tbody>{body}</tbody>
      </table>
    );
  };

  if (isLoading) {
    return (
      <Loading type="table" showText={items.length === 0} />
    );
  }

  if (!isLoading && items.length + rows.length === 0) {
    return (
      <div className="no-results">
        <p>{ emptyText }</p>
      </div>
    );
  }

  return table(headers, items.length ? items : rows);
}

export default Table;
